import React from 'react';

import DefaultLayout from 'src/layouts/DefaultLayout';
import DashBoard from 'src/pages/DashBoard';
import Campuses from 'src/pages/Campuses';
import Credits from 'src/pages/Credits';
import IframePage from 'src/pages/Iframe';

const HeadManager = () => {
  return (
    <>
      <DefaultLayout exact path="/dashboard" component={DashBoard} />
      <DefaultLayout exact path="/campus" component={Campuses} />
      <DefaultLayout exact path="/credit" component={Credits} />
      <DefaultLayout exact path="/i-frame/:url" component={IframePage} isHeaderStatic={true} />
      <DefaultLayout exact path="/" component={DashBoard} />
    </>
  );
};

export default HeadManager;
